export default __webpack_public_path__ + "static/media/Increase_sales_sell_more_embed_videos.fe8078a9.gif";